import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./style.scss";
import App from "./App";
import { ThemeProvider } from "./ThemeContext";
import { CacheProvider } from "./contexts/CacheContext";
import ScrollToTopOnNavigate from "./utilities/ScrollToTopOnNavigate";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <CacheProvider>
      <ThemeProvider>
        <ScrollToTopOnNavigate />
        <App />
      </ThemeProvider>
    </CacheProvider>
  </BrowserRouter>
);
